class DoclrEnumSwitchDirective {
    constructor() {
        'ngInject';
        this.restrict = 'E';
        this.templateUrl = '/partials/components/utils/doclr.enum.switch.html';
        this.scope = {
            onChange: '&',
            enumName: '@',
            enumValues: '<'
        };
        this.require = 'ngModel';

    }

    controller($scope, $state,) {
        $scope.state = $state;
    }

    link(scope, element, attrs, ngModelCtrl) {
        scope.setValue = function (value) {
            if(scope.model === value && !attrs.required){
                value = null;
            }
            scope.model = value;
            ngModelCtrl.$setViewValue(scope.model);
        };

        ngModelCtrl.$render = function () {
            scope.model = ngModelCtrl.$viewValue;
        };
    }
}

(function () {
    'use strict';

    angular.module('doclr.components.util')
        .directive('doclrEnumSwitch', () => new DoclrEnumSwitchDirective());
})();